import { Record, Map, List } from 'immutable';
import { fetchSettingsActions, fetchSitesActions, saveActions, fetchDemographicsActions, pagingActions, actionTypes } from './demographics.actions';
import { submitDemographicsEnabledStatusActions } from '../permissions.actions';
import * as api from '../../api';
import { pagingDataUtilities } from '../../common';

export const DemographicPermission = Record({
  demographicId : '',
  view : undefined,
  edit : undefined,
});

export const DemographicsState = Record({
  settings : api.ApiCallState({}),
  sites : api.ApiCallState({}),
  save : api.ApiCallState({}),
  allDemographics : api.ApiCallState({}),
  demographicsPagingData: pagingDataUtilities.PagingState({
    itemsPerPage : 50
  }),
  permissionsResponse : Map({}),
  showConfirmSettingsModalDemoEnabled: false,
  showConfirmSettingsModalDemoDisabled: false,
  selectedSaveOption : 'yes'
});

export const demographicsReducer = (initialState = new DemographicsState(), action) => {
  var state = initialState;
  state = state.set('demographicsPagingData',
    pagingDataUtilities.pagingReducer(state.get('demographicsPagingData'), action, pagingActions));

  const invalidateSettingsActions = [saveActions.success, submitDemographicsEnabledStatusActions.success];
  state = state.set('settings',
    api.apiCallReducer(state.get('settings'), action, fetchSettingsActions, invalidateSettingsActions));
  state = state.set('sites',
    api.apiCallReducer(state.get('sites'), action, fetchSitesActions));
  state = state.set('save',
    api.apiCallReducer(state.get('save'), action, saveActions));
  const invalidateDemographics = pagingActions.allTypes.concat([saveActions.success]);
  state = state.set('allDemographics',
    api.apiCallReducer(state.get('allDemographics'), action, fetchDemographicsActions, invalidateDemographics));
  switch(action.type) {
    case actionTypes.UPDATE_SITE:
      return state.setIn(['permissionsResponse', 'defaultSite'], action.siteId);
    case actionTypes.UPDATE_PERMISSION: {
      var permissions = state.getIn(['permissionsResponse', 'permissions']);
      if(!permissions) {
        permissions = new List([]);
      }
      var index = permissions.findIndex(val => val.demographicId === action.demographicId);
      if(index === -1) {
        permissions = permissions.push(new DemographicPermission({
          demographicId : action.demographicId,
        }));
        index = permissions.findIndex(val => val.demographicId === action.demographicId);
      }
      var modifiedState = state.setIn(['permissionsResponse', 'permissions'], permissions);
      return modifiedState.setIn(['permissionsResponse', 'permissions', index, action.section], action.value);
    }
    case saveActions.success:
    case actionTypes.CLEAR_ANSWERS:
      return state.set("permissionsResponse", Map({}));
    case actionTypes.SHOW_CONFIRM_SETTINGS_MODAL_DEMO_ENABLED:
      return state.set('showConfirmSettingsModalDemoEnabled', action.show);
    case actionTypes.SHOW_CONFIRM_SETTINGS_MODAL_DEMO_DISABLED:
      return state.set('showConfirmSettingsModalDemoDisabled', action.show);
    case actionTypes.SET_SELECTED_SAVE_OPTION:
      return state.set('selectedSaveOption', action.optionId);
    case actionTypes.UPDATE_DEMOGRAPHICS_ENABLED:
      return state.setIn(['permissionsResponse', 'enableDemographics'], action.enabled);
    default: return state;
  }
}
